import React, { useEffect } from "react";
import { NoTokenError, isEmailConfirmationRequiredError } from "@rentablo/api";
import { useLoginRoute } from "./useLoginRoute";

const BASE_PATH = import.meta.env.VITE_APP_V2_URL;
const EMAIL_CONFIRMATION_PATH = "/confirmation/email";
const EMAIL_CONFIRMATION_URL = `${BASE_PATH}${EMAIL_CONFIRMATION_PATH}`;

export interface Props {
  error?: AxiosApiError | NoTokenError;
  clearAuthStates?: () => void;
}

export const LoginOrConfirmation = ({ error, clearAuthStates }: Props) => {
  const { loginRedirectUrl, isLoginPath } = useLoginRoute();
  const inLoginPage = isLoginPath(window.location.pathname);
  const isNoTokenError = error?.name === "NoTokenError";
  const isRefreshTokenError = error?.name === "RefreshTokenError";
  const is401 = (error as AxiosApiError)?.response?.status === 401;
  const isEmailConfirmationRequired =
    is401 && isEmailConfirmationRequiredError(error as AxiosApiError);
  const inEmailConfirmationPage =
    window.location.pathname === EMAIL_CONFIRMATION_PATH;

  const showLoginForm =
    isNoTokenError ||
    isRefreshTokenError ||
    (is401 && !isEmailConfirmationRequired);

  useEffect(() => {
    if (showLoginForm && !inLoginPage) {
      window.location.href = loginRedirectUrl;
    } else if (isEmailConfirmationRequired && !inEmailConfirmationPage) {
      window.location.href = EMAIL_CONFIRMATION_URL;
    }

    if (inEmailConfirmationPage || inLoginPage) {
      clearAuthStates?.();
    }
  }, [
    inEmailConfirmationPage,
    inLoginPage,
    clearAuthStates,
    isEmailConfirmationRequired,
    showLoginForm,
    loginRedirectUrl,
  ]);

  return <></>;
};
